module.exports = __webpack_public_path__ + "static/media/group.9e8f36dd.jpg";